"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedPersonas = void 0;

var actions = _interopRequireWildcard(require("../actions"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var initialState = {
  personas: [],
  isHidden: false
};

var selectedPersonas = function selectedPersonas( // $FlowFixMe
state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case actions.ADD_SELECTED_PERSONA:
      return _extends({}, state, {
        personas: [].concat(state.personas, [action.payload])
      });

    case actions.UPDATE_SELECTED_PERSONA:
      return _extends({}, state, {
        // $FlowFixMe
        personas: [].concat(state.personas.slice(0, action.index), action.payload, state.personas.slice(action.index + 1))
      });

    /* eslint-disable no-case-declarations */

    case actions.REMOVE_SELECTED_PERSONA:
      var copy = state.personas; // $FlowFixMe

      copy = copy.filter(function (value) {
        return value.id !== action.payload.id;
      });
      return _extends({}, state, {
        personas: [].concat(copy)
      });

    case actions.SET_SELECTED_PERSONAS:
      return _extends({}, state, {
        personas: [].concat(action.payload)
      });

    case actions.RESET_PAGE_DATA:
    case actions.SET_AUDIENCE_VIEW:
    case actions.RESET_SELECTED_PERSONAS:
      return _extends({}, state, initialState);

    case actions.TOGGLE_SEGMENT_SELECTION_VISIBILITY:
      return _extends({}, state, {
        isHidden: action.payload
      });

    default:
      return state;
  }
};

exports.selectedPersonas = selectedPersonas;